import * as React from 'react';
import { connect } from 'react-redux';
import { Text, Body } from 'native-base';
//import { LayoutAnimation } from 'react-native';
import PeopleList from '../../components/peopleList';
//import datas from "./data";
import { fetchList, deletePerson } from './actions';
import * as _ from 'lodash';

class PeopleListContainer extends React.Component {
	componentDidMount() {
		if (__DEV__) console.log(this.props.route);
	}

	render() {
		var data, refreshing;
		if (this.props.peopleType == 'search') {
			if (!this.props.searchString || this.props.searchString.length < 2)
				return (
					<Text note style={{ margin: 20 }}>
						Type to search
					</Text>
				);
			const val = this.props.searchString.toLowerCase();
			data = _.filter([...this.props.customers, ...this.props.suppliers], function (rec) {
				return rec.name.toLowerCase().indexOf(val) === 0 || rec.name.toLowerCase().indexOf(' ' + val) > -1 || rec.businessName.toLowerCase().indexOf(val) === 0;
			});
			data = _.sortBy(data, ['businessName', 'name']);
			__DEV__ && console.log(this.props.searchString, val, this.props.customers, data);
			if (!data.length)
				return (
					<Text note style={{ margin: 20 }}>
						No results
					</Text>
				);
			refreshing = this.props.customersLoading || this.props.suppliersLoading;
		} else {
			data = this.props.peopleType == 'customers' ? this.props.customers : this.props.suppliers;
			refreshing = this.props.peopleType == 'customers' ? this.props.customersLoading : this.props.suppliersLoading;
		}
		//console.log('people data ',this.props.peopleType, data);
		return <PeopleList refreshing={refreshing} navigation={this.props.navigation} list={data} doRefresh={() => this.doRefresh()} onSelectCustomer={item => this.onSelectCustomer(item)} />;
	}

	onSelectCustomer(item) {
		__DEV__ && console.log(item);
		//LayoutAnimation.linear();
		this.props.navigation.navigate('PersonDetails', {
			personType: item.personType,
			personId: item.id
		});
	}

	doRefresh() {
		//console.log('about to refresh', this.props[this.props.peopleType]);
		if (this.props.peopleType == 'search') return; // :(
		this.props.fetchList(this.props.peopleType);
	}
}

function bindAction(dispatch) {
	return {
		fetchList: token => dispatch(fetchList(token))
	};
}

const mapStateToProps = state => ({
	customers: state.globalReducer.customers,
	suppliers: state.globalReducer.suppliers,
	customersLoading: state.customersReducer.customersLoading,
	suppliersLoading: state.customersReducer.suppliersLoading
});
export default connect(mapStateToProps, bindAction)(PeopleListContainer);
